interface LogEntry {
    timestamp: string;
    level: 'info' | 'warn' | 'error' | 'debug';
    component: string;
    message: string;
    data?: any;
}

class AuthLogger {
    private static logs: LogEntry[] = [];
    private static maxLogs = 100;

    static info(component: string, message: string, data?: any) {
        this.log('info', component, message, data);
    }

    static warn(component: string, message: string, data?: any) {
        this.log('warn', component, message, data);
    }

    static error(component: string, message: string, data?: any) {
        this.log('error', component, message, data);
    }

    static debug(component: string, message: string, data?: any) {
        this.log('debug', component, message, data);
    }

    private static log(level: 'info' | 'warn' | 'error' | 'debug', component: string, message: string, data?: any) {
        const entry: LogEntry = {
            timestamp: new Date().toISOString(),
            level,
            component,
            message,
            data
        };

        this.logs.unshift(entry);

        // Keep only the last maxLogs entries
        if (this.logs.length > this.maxLogs) {
            this.logs = this.logs.slice(0, this.maxLogs);
        }

        // Console logging with emoji
        const emoji = {
            info: 'ℹ️',
            warn: '⚠️',
            error: '❌',
            debug: '🔍'
        }[level];

        console.log(`${emoji} [${component}] ${message}`, data || '');
    }

    static getLogs(): LogEntry[] {
        return [...this.logs];
    }

    static clearLogs() {
        this.logs = [];
    }
}

export default AuthLogger;